define('shared/page/partner',[
    'shared/lib/RSVP', 
    'shared/util/state', 
    'shared/util/state/adapters/page',
    'shared/util/state/adapters/session'
], function (
    RSVP,
    state, 
    pageAdapter,
    sessionAdapter
) {
    'use strict';

    return function(){
        return RSVP.all([
                state.adapters.add(pageAdapter),
                state.adapters.add(sessionAdapter)
            ])
            .then(function(){
                return state
                    .get('page.partner_code', 'session.partner_code');
            })
            .then(function(values){
                return values[0] || values[1] || '';
            });
    };
});
